<div class="inner-content" (click)="callAudio.enableSound()">
  <app-call-status-bar/>
  <app-network-disconnect-notice />
  <router-outlet></router-outlet>
  <nz-spin *ngIf="isSpinning" [nzSpinning]="isSpinning" class="overlay">
  </nz-spin>
</div>
